import React from 'react';
export function SocialProofStats() {
  return <section className="w-full bg-brand-violet py-6 px-4" data-id="element-265">
      <div className="max-w-2xl mx-auto flex flex-row items-center justify-between divide-x divide-white/20" data-id="element-266">
        <div className="flex-1 flex flex-col items-center justify-center px-1 text-center" data-id="element-267">
          <span className="text-white font-bold text-lg sm:text-2xl leading-none mb-1" data-id="element-268">
            +1.500
          </span>
          <span className="text-white/70 text-[8px] sm:text-[10px] font-semibold uppercase tracking-wider leading-tight" data-id="element-269">
            MUJERES TODO EL PAÍS
          </span>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center px-1 text-center" data-id="element-270">
          <span className="text-white font-bold text-lg sm:text-2xl leading-none mb-1" data-id="element-271">
            9
          </span>
          <span className="text-white/70 text-[8px] sm:text-[10px] font-semibold uppercase tracking-wider leading-tight" data-id="element-272">
            TOMOS Y BONUS
          </span>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center px-1 text-center" data-id="element-273">
          <span className="text-white font-bold text-lg sm:text-2xl leading-none mb-1" data-id="element-274">
            4.9/5 ⭐
          </span>
          <span className="text-white/70 text-[8px] sm:text-[10px] font-semibold uppercase tracking-wider leading-tight" data-id="element-275">
            CALIFICACIÓN
          </span>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center px-1 text-center" data-id="element-276">
          <span className="text-white font-bold text-lg sm:text-2xl leading-none mb-1" data-id="element-277">
            🇦🇷
          </span>
          <span className="text-white/70 text-[8px] sm:text-[10px] font-semibold uppercase tracking-wider leading-tight" data-id="element-278">
            TODO EL PAÍS
          </span>
        </div>
      </div>
    </section>;
}